export async function relocateAllInlocationUseCase(locationId, relocationRepository) {
    const result = await relocationRepository.relocate_all_in_location(locationId);

    result.data.success.arguments.forEach(x => {
        x = new relocationRepository.model(x);

        if (!x.isValid()) {
            throw new Error("Reubicación inválida");
        }
    })

    return result;
}